import React from 'react';
import PropTypes from 'prop-types';
import { Paper, TableRow, TableBody, TableCell, Typography } from '@mui/material';

const EmptyTableBody = ({ filterName }) => (
  <TableBody>
    <TableRow>
      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
        <Paper>
          <Typography variant="h6" paragraph>
            Not found
          </Typography>

          {filterName && (
            <Typography variant="body2">
              No results found for &nbsp;
              <strong>&quot;{filterName}&quot;</strong>.
              <br /> Try checking for typos or using complete words.
            </Typography>
          )}
        </Paper>
      </TableCell>
    </TableRow>
  </TableBody>
);

EmptyTableBody.propTypes = {
  filterName: PropTypes.string,
};

export default EmptyTableBody;
